import React, { useState, useEffect } from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import "./OvertimeApplication.css";
import OvertimeApplicationLayout from "../layouts/Employee/OvertimeApplicationLayout";

function OvertimeApplication() {
  return (
    <div className="overtime-application-bg">
      <Header />
      <SubHeader />
      <OvertimeApplicationLayout />
    </div>
  );
}

export default OvertimeApplication;
